import {logErrorMessages} from '@vue/apollo-util'

export const onErrorCallBack = (error) => {
    console.log('error that happened')
    logErrorMessages(error)
}
